<div class="py-8 px-4 sm:px-6 lg:px-8"></div>
    <div class="max-w-5xl mx-auto">
        <!-- Header -->
        <header class="text-center mb-8">
            <h1 class="text-4xl font-bold text-blue-600 dark:text-blue-400 mb-4 pb-4 border-b-2 border-blue-600 dark:border-blue-400">
                Aviso de Privacidad Integral para ReliefApp.org
            </h1>
            <p class="text-gray-600 dark:text-gray-300 font-semibold">
                <strong>Fecha de Última Actualización:</strong> 14 de octubre de 2025
            </p>
        </header>

        <main class="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-8 space-y-8">
            <!-- 1. Identidad y Domicilio del Responsable -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    1. Identidad y Domicilio del Responsable
                </h2>
                <p class="text-gray-700 dark:text-gray-300 mb-3">
                    <strong>Relief Daily</strong> (en adelante, "El Responsable" o "ReliefApp") con domicilio en 
                    <strong>México</strong> es el responsable del tratamiento de los datos personales que se recaban a través del sitio web y aplicación móvil **reliefapp.org**.
                </p>
                <p class="text-gray-700 dark:text-gray-300">
                    Para cualquier duda relacionada con la protección de sus datos personales, puede contactarnos a través del siguiente correo electrónico: 
                    <strong class="text-blue-600 dark:text-blue-400">
                        <a href="mailto:privacidad@reliefapp.org" class="hover:underline">privacidad@reliefapp.org</a>
                    </strong>.
                </p>
            </section>

            <!-- 2. Datos Personales Recabados -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    2. Datos Personales Recabados
                </h2>
                <p class="text-gray-700 dark:text-gray-300 mb-4">
                    ReliefApp recaba los siguientes datos personales, incluyendo, en su caso, datos sensibles, con base en las interacciones que tenga el usuario con la plataforma:
                </p>
                
                <div class="overflow-x-auto">
                    <table class="w-full border-collapse border border-gray-300 dark:border-gray-600 mb-6">
                        <thead>
                            <tr class="bg-gray-100 dark:bg-slate-700">
                                <th class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left text-gray-900 dark:text-gray-100 font-semibold">Categoría de Datos</th>
                                <th class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left text-gray-900 dark:text-gray-100 font-semibold">Tipo de Dato</th>
                                <th class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left text-gray-900 dark:text-gray-100 font-semibold">Recolección</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Datos de Identificación del Usuario</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    Correo electrónico, ID de usuario.
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Necesario</strong> para el uso del servicio y la creación de la cuenta.
                                </td>
                            </tr>
                            <tr class="bg-gray-50 dark:bg-slate-700">
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Datos Sensibles (Contenido)</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    El texto que el usuario escribe para "desahogarse" (sus pensamientos y sentimientos).
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Esencial</strong> para el funcionamiento del servicio. Se enfatiza el tratamiento seguro y encriptado de los datos.
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Datos Operacionales/Estadísticos</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    Cantidad de "reliefs" creados, Sentimientos asociados (feliz, triste, etc.), Colores elegidos por el usuario.
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Necesario</strong> para la funcionalidad de métricas personales y tendencias.
                                </td>
                            </tr>
                            <tr class="bg-gray-50 dark:bg-slate-700">
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Datos Técnicos</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    Dirección IP (para seguridad), datos de uso de la aplicación, información del dispositivo/navegador.
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>Automático</strong> al utilizar la aplicación/web.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="border-2 border-yellow-400 bg-yellow-50 dark:bg-yellow-900/30 p-6 rounded-lg">
                    <h3 class="text-lg font-semibold text-yellow-800 dark:text-yellow-300 mb-3">
                        Nota Importante sobre Datos Sensibles (Contenido de "Reliefs"):
                    </h3>
                    <ul class="list-disc ml-6 text-yellow-800 dark:text-yellow-300 space-y-2">
                        <li>Los pensamientos y sentimientos que escribes son considerados <strong>Datos Personales Sensibles</strong>.</li>
                        <li>Para garantizar su seguridad, esta información <strong>se encripta en su dispositivo antes de ser enviada</strong> y se almacena en nuestra base de datos <strong>ya encriptada</strong>.</li>
                        <li><strong>Solo usted</strong>, a través de su clave de encriptación asociada a su cuenta, tiene la capacidad de descifrar y acceder a esta información.</li>
                        <li><strong>El Responsable no tiene la llave de desencriptación</strong> para acceder al contenido de sus "reliefs".</li>
                    </ul>
                </div>
            </section>

            <!-- 3. Finalidades del Tratamiento -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    3. Finalidades del Tratamiento de Datos
                </h2>
                <p class="text-gray-700 dark:text-gray-300 mb-4">
                    Los datos personales son tratados para las siguientes finalidades:
                </p>
                
                <div class="overflow-x-auto">
                    <table class="w-full border-collapse border border-gray-300 dark:border-gray-600">
                        <thead>
                            <tr class="bg-gray-100 dark:bg-slate-700">
                                <th class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left text-gray-900 dark:text-gray-100 font-semibold">Finalidad</th>
                                <th class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left text-gray-900 dark:text-gray-100 font-semibold">Tipo</th>
                                <th class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left text-gray-900 dark:text-gray-100 font-semibold">Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>A. Proveer y Mantener el Servicio</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Necesaria</td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    Crear y gestionar su cuenta, permitir el acceso a la plataforma, almacenar de forma segura su contenido encriptado.
                                </td>
                            </tr>
                            <tr class="bg-gray-50 dark:bg-slate-700">
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>B. Seguridad y Mejora del Servicio</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Necesaria</td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    Monitorear el rendimiento, prevenir fraudes, proteger la seguridad mediante encriptación.
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>C. Comunicación con el Usuario</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Necesaria</td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    Notificaciones del servicio (restablecimiento de contraseña, cambios en el servicio).
                                </td>
                            </tr>
                            <tr class="bg-gray-50 dark:bg-slate-700">
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>D. Fines Publicitarios o Marketing</strong>
                                </td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-red-600 dark:text-red-400 font-semibold">No Aplica</td>
                                <td class="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">
                                    <strong>ReliefApp.org NO utiliza sus datos para fines publicitarios</strong> o para venderlos a terceros.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <!-- 4. Transferencia de Datos -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    4. Transferencia de Datos Personales
                </h2>
                <p class="text-gray-700 dark:text-gray-300 mb-4">
                    ReliefApp.org se compromete a no transferir sus Datos Personales a terceros, <strong>excepto</strong> en los casos que sean estrictamente necesarios para la operación del servicio:
                </p>
                <ul class="list-disc ml-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                    <li>A proveedores de servicios de alojamiento (Firebase) con garantía de que los datos sensibles se almacenan encriptados.</li>
                    <li>Para cumplir con requerimientos legales, judiciales o administrativas.</li>
                </ul>
                <p class="text-gray-700 dark:text-gray-300 font-semibold">
                    <strong>En ningún caso el contenido encriptado de sus "reliefs" será compartido o vendido.</strong>
                </p>
            </section>

            <!-- 5. Medidas de Seguridad -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    5. Medidas de Seguridad Implementadas
                </h2>
                <p class="text-gray-700 dark:text-gray-300 mb-4">
                    Para la protección de sus Datos Personales, hemos implementado las siguientes medidas de seguridad:
                </p>
                <ul class="list-disc ml-6 text-gray-700 dark:text-gray-300 space-y-2">
                    <li><strong>Cifrado de Extremo a Extremo:</strong> Sus pensamientos son encriptados en su dispositivo antes de ser transmitidos.</li>
                    <li><strong>Almacenamiento Cifrado:</strong> Todos los datos sensibles se almacenan encriptados en Firebase.</li>
                    <li><strong>Restricción de Acceso:</strong> El personal de ReliefApp no tiene acceso a las claves de descifrado.</li>
                    <li><strong>Conexiones Seguras:</strong> Uso de SSL/TLS para todas las comunicaciones.</li>
                    <li><strong>Eliminación Automática:</strong> Opción de eliminación automática en 24 horas para mayor privacidad.</li>
                </ul>
            </section>

            <!-- 6. Derechos ARCO -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    6. Derechos ARCO y Revocación del Consentimiento
                </h2>
                <p class="text-gray-700 dark:text-gray-300 mb-4">
                    Usted tiene derecho a conocer qué datos personales tenemos (Acceso), a corregirlos (Rectificación), a eliminarlos (Cancelación) y a oponerse al uso (Oposición). Estos son los <strong>Derechos ARCO</strong>.
                </p>
                <p class="text-gray-700 dark:text-gray-300 mb-4">
                    Para ejercer cualquiera de los Derechos ARCO, deberá enviar una solicitud al correo: 
                    <strong class="text-blue-600 dark:text-blue-400">
                        <a href="mailto:privacidad@reliefapp.org" class="hover:underline">privacidad@reliefapp.org</a>
                    </strong>
                </p>
                <p class="text-gray-700 dark:text-gray-300 mb-2">La solicitud deberá contener:</p>
                <ul class="list-disc ml-6 text-gray-700 dark:text-gray-300 space-y-2">
                    <li>Su nombre y medio de contacto para comunicarle la respuesta.</li>
                    <li>Documentos que acrediten su identidad (copia de identificación oficial).</li>
                    <li>Descripción clara de los datos respecto a los que busca ejercer algún derecho ARCO.</li>
                    <li>Cualquier elemento que facilite la localización de los datos personales.</li>
                </ul>
            </section>

            <!-- 7. Cambios al Aviso -->
            <section>
                <h2 class="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 pb-2 border-b border-gray-300 dark:border-gray-600">
                    7. Cambios al Aviso de Privacidad
                </h2>
                <p class="text-gray-700 dark:text-gray-300">
                    El presente Aviso de Privacidad puede sufrir modificaciones derivadas de nuevos requerimientos legales o necesidades del servicio. 
                    Nos comprometemos a mantenerlo informado sobre los cambios a través de la publicación en 
                    <strong>reliefapp.org/privacy-policy</strong> o mediante notificación por correo electrónico.
                </p>
            </section>
        </main>

            <!-- Botón para volver -->
    <div class="mt-8 text-center">
      <button (click)="goBack()" class="back-button inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-700">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
        </svg>
        Volver
      </button>
    </div>

        <!-- Footer -->
        <footer class="text-center mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p class="text-gray-500 dark:text-gray-400">
                &copy; 2025 ReliefApp.org. Todos los derechos reservados.
            </p>
        </footer>
    
</div>